import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { configureStore, ThunkAction, Action, combineReducers } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import { innovorderApi } from 'services';
import storage from 'redux-persist/lib/storage';
import { brandSlice } from './brand';
import { appSlice } from './app';
import { menuSlice } from './menu';
import { orderSlice } from './order';
import { consumptionModeListSlice } from './consumptionModeList';

const persistConfig = {
    key: 'root',
    blacklist: ['api'],
    storage,
};

const rootReducer = combineReducers({
    brand: brandSlice.reducer,
    app: appSlice.reducer,
    menu: menuSlice.reducer,
    order: orderSlice.reducer,
    consumptionModeList: consumptionModeListSlice.reducer,
    [innovorderApi.reducerPath]: innovorderApi.reducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const configureStoreWithPreloadedState = (preloadedState?: any) =>
    configureStore({
        reducer: persistedReducer,
        middleware: (getDefaultMiddleware) =>
            getDefaultMiddleware({
                serializableCheck: false,
            }).concat(innovorderApi.middleware),
        preloadedState,
    });

export const store = configureStoreWithPreloadedState();
export type AppStore = typeof store;

export const persistor = persistStore(store);

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
    ReturnType,
    RootState,
    unknown,
    Action<string>
>;

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
